module.exports = __webpack_public_path__ + "img/news-01.0f8dfdfb.png";